import React from "react"
import { Trans, InfoWrapper } from "../StyledComponents"
import domtoimage from "dom-to-image"

export const Overview = ({ selected }) => {
    if (!selected.textiles) return null
    return (
        <InfoWrapper>
            <dl>
                <dt>
                    <Trans>Bed</Trans>
                </dt>
                <dd>{selected.bed.title}</dd>
                <dt>
                    <Trans>Textile</Trans>
                </dt>
                <dd>
                    {selected.textiles.title}
                    {selected.textiles.seamless && " - Seamlesss"}
                </dd>
                <dt>
                    <Trans>Topper</Trans>
                </dt>
                <dd>{selected.topper.title}</dd>
                <dt>
                    <Trans>Legs</Trans>
                </dt>
                <dd>{selected.legs.title}</dd>
                {selected.headboards && (
                    <>
                        <dt>
                            <Trans>Headboard</Trans>
                        </dt>
                        <dd>{selected.headboards.title}</dd>
                    </>
                )}
                {selected.bedsidetable && (
                    <>
                        <dt>
                            <Trans>Bedside tables</Trans>
                        </dt>
                        <dd>{selected.bedsidetable.title}</dd>
                    </>
                )}

                {selected.ottoman && (
                    <>
                        <dt>
                            <Trans>Ottoman</Trans>
                        </dt>
                        <dd>{selected.ottoman.title}</dd>
                    </>
                )}
                {selected.addons && selected.addons.length > 0 && (
                    <>
                        <dt>
                            <Trans>Add ons</Trans>
                        </dt>
                        {selected.addons.map((v, i) => (
                            <dd key={i}>{v.title}</dd>
                        ))}
                    </>
                )}
            </dl>
            <button
                onClick={() => {
                    domtoimage
                        .toJpeg(document.getElementById("main-stage"), {
                            quality: 0.95,
                            filter: node => {
                                return (
                                    node.tagName !== "svg" &&
                                    !node.classList.contains("overview-box")
                                )
                            }
                        })
                        .then(function(dataUrl) {
                            var link = document.createElement("a")
                            link.download = "my-new-bed.jpeg"
                            link.href = dataUrl
                            link.click()
                        })
                }}>
                Save bed image
            </button>
        </InfoWrapper>
    )
}
